
import { Outlet, useRoutes } from 'react-router-dom';
import Navigation from './Navigation';
import FirmEntry from './Master/FirmEntry';
import FirmTable from './MasterTables/FirmTable/FirmTable';
import FirmEdit from './MasterEdit/FirmEdit';
import EmployeeEntry from './Master/EmployeeEntry';
import EmpTable from './MasterTables/EmployeeTable/EmpTable';
import EmployeeEdit from './MasterEdit/EmployeeEdit';
import DepartmentEntry from './Master/DepartmentEntry';
import DepartmentTable from './MasterTables/DepartmentTable/DepartmentTable';
import DepartmentEdit from './MasterEdit/DepartmentEdit';
import PannaEntry from './Master/PannaEntry';
import PannaTable from './MasterTables/PannaTable/PannaTable';
import PannaEdit from './MasterEdit/PannaEdit';
import ClothEntry from './Master/ClothEntry';
import ClothTable from './MasterTables/ClothTable/ClothTable';
import ClothEdit from './MasterEdit/ClothEdit';
import SalePurchaseEntry from './Master/SalePurchaseEntry';
import SalePurchaseTbl from './MasterTables/SalePurchaseTable/SalePurchaseTbl';
import SalePurchaseEdit from './MasterEdit/SalePurchaseEdit';
import ItemMaster from './Master/ItemMaster';
import ItemTbl from './MasterTables/ItemTable/ItemTbl';
import ItemEdit from './MasterEdit/ItemEdit';
import PannaItemAverage from './Master/PannaItemAverage';
import RackEntry from './Master/RackEntry';
import RackTable from './MasterTables/RackTbl/RackTable';
import RackEdit from './MasterEdit/RackEdit';
import SchoolEntry from './Master/SchoolEntry';
import SchoolEdit from './MasterEdit/SchoolEdit';
import SchoolTable from './MasterTables/SchlTable/SchoolTable';
import TransportEntry from './Master/TransportEntry';
// import TransportBailEntry from './Master/TransportBailEntry';
// import TransportBailRegister from './Master/TransportBailRegister';
// import TransportBailWhatsappSendReg from './Master/TransportBailWhatsappSendReg';
import TransportTable from './MasterTables/TransportTbl/TransportTable';
import TransportEdit from './MasterEdit/TransportEdit';
import LogoEntry from './Master/LogoEntry';
import LogoTable from './MasterTables/LogoTbl/LogoTable';
import LogoEdit from './MasterEdit/LogoEdit';
import MaterialEntry from './Master/MaterialEntry';
import MaterialTable from './MasterTables/MaterialTbl/MaterialTable';
import MaterialEdit from './MasterEdit/MaterialEdit';
import MatInwardEntry from './Master/MatInwardEntry';
import MatOutwardEntry from './Master/MatOutwardEntry';
import MatInwardTable from './MasterTables/MatInwardTbl/MatInwardTable';
import MatInwardView from './MasterTables/MatInwardTbl/MatInwardView';
import MatInwardBarcode from './MasterTables/MatInwardTbl/MatInwardBarcode';
import MatOutwardTable from './MasterTables/MatOutwardTbl/MatOutwardTable';
import MatStockTable from './MasterTables/MatStockTbl/MatStockTable';
import ClothStkEntry from './UploadStock/ClothStkEntry';
import MatInwardEdit from './MasterEdit/MatInwardEdit';
import MatOutwardEdit from './MasterEdit/MatOutwardEdit';
import MatStockView from './MasterTables/MatStockTbl/MatStockView';
import ReadyMStkEntry from './UploadStock/ReadyMStkEntry';
import ClothStkTable from './UploadStkTable/ClothStkTbl/ClothStkTable';
import ClothStkEdit from './UploadStkEdit/ClothStkEdit';
import ReadyMStkTable from './UploadStkTable/ReadyMStkTbl/ReadyMStkTable';
import ReadyMStkEdit from './UploadStkEdit/ReadyMStkEdit';
import PricePercentGEntry from './Sale/PricePercentGEntry';
import PurchaseOrderEntry from './Purchase/PurchaseOrderEntry';
import JobRateEntry from './Master/JobRateEntry';
import JobRateTable from './MasterTables/JobRateTbl/JobRateTable';
import PricePercentTable from './SaleTables/PricePercentTbl/PricePerTable';
import PurchaseInwardEntry from './Inward/PurchaseInwardEntry';
import NewItemEntry from './NewEntry/NewItemEntry';
import NewClothEntry from './NewEntry/NewClothEntry';
import PurchaseOrderTable from './PurchaseTables/PurchaseOrderTbl/PurchaseOrderTable';
import POExtraEntry from './Purchase/POExtraEntry';
import DirectPurchaseInwEntry from './Inward/DirectPIEntry';
import PurInwardTable from './InwardTables/PurchaseInwardTbl/PurInwardTable';
import NewPartyEntry from './NewEntry/NewPartyEntry';
import QuotationEntry from './Sale/QuotationEntry';
import NewSchoolEntry from './NewEntry/NewSchoolEntry';
import QuotationTable from './SaleTables/QuotationTbl/QuotationTable';
import SaleOrder from './Sale/SaleOrder';
import NewLogoEntry from './NewEntry/NewLogoEntry';
import NewTransportEntry from './NewEntry/NewTransportEntry';
import SaleOrderTable from './SaleTables/SaleOrdTbl/SaleOrderTable';
import SaleOrderRate from './Sale/SORate';
import SORateManually from './Sale/SORateManually';
import SOWiseEntry from './CuttingMukul/SOWiseEntry';
import CutManuallyEntry from './CuttingMukul/CutManuallyEntry';
import QuotationView from './Sale/View/QuotationView';
import QuotationInfo from './SaleTables/View/QuotationInfo';
import QuotPrint from './SaleTables/View/QuotPrint';
import RateChange from './SaleTables/View/RateChange';
import RateAnalysis from './SaleTables/View/RateAnalysis';
import SOqtwise from './Sale/SOqtwise';
import DirectSO from './Sale/DirectSO';
import SOInfo from './SaleTables/View/SOInfo';
import SOMaterialInfo from './SaleTables/View/SOMaterialInfo';
import CategoryEntry from './WorkerMaster/CategoryEntry';
import CutSOwise from './Cutting/CutSOwise';
import ClothIssueEntry from './Cutting/ClothIssueEntry';
import ClothIssueReg from './CuttingTable/ClothIssueTbl/ClothIssueReg';
import ClothIssueView from './CuttingTable/View/ClothIssueView';
import CuttingEntry from './Cutting/CuttingEntry';
import CuttingRegister from './CuttingTable/CuttingTbl/CuttingRegister';
import CuttingInfoView from './CuttingTable/View/CuttingInfoView';
import CuttingInward from './Cutting/CuttingInward';
import ContractorEntry from './Cutting/ContractorEntry';
import ContractorInward from './Cutting/ContractorInward';
import ContractorReg from './CuttingTable/ContractorTbl/ContractorReg';
import CuttingReturnReg from './CuttingTable/CutReturnTbl/CuttingReturnReg';
import ContractorReturnReg from './CuttingTable/ContractorReturnTbl/ContractorReturnReg';
import CutReturnInfo from './CuttingTable/View/CutReturnInfo';
import ContReturnInfo from './CuttingTable/View/ContReturnInfo';
import StitchInhouseEntry from './Stitching/StitchInhouseEntry';
import ClothIssueEdit from './CuttingEdit/ClothIssueEdit';
import MainReturnInfo from './CuttingTable/View/MainReturnInfo';
import MainContReturnInfo from './CuttingTable/View/MainContReturnInfo';
import SaleOrderEdit from './SaleEdit/SaleOrderEdit';
import CuttingInEdit from './CuttingEdit/CuttingInEntryEdit';
import CuttingFinalPrint from './CuttingTable/View/CutFinalPrint';
import ContCutFinalPrint from './CuttingTable/View/ContFinalPrint';
import StitchingReg from './StitchingTbl/StitchRegister/StitchingReg';
import StitchingInfo from './StitchingTbl/View/StitchingInfo';
import StitchingReturn from './Stitching/StitchingReturn';
import StitchReturnReg from './StitchingTbl/StitchReturn/StitchReturnReg';
import KajeEntry from './Kaje/KajeEntry';
import KajeRegister from './KajeTbl/KajeTable/KajeRegister';
import KajeInfo from './KajeTbl/View/KajeInfo';
import PressingEntry from './Press/PressingEntry';
import KjPrIssueInw from './KPIssueinward/KjPrIssueInw';
import StockEntryProduction from './Stock/StockEntryProduction';
import StitchContractorEntry from './Stitching/StitchContractorEntry';
import StitchContractorReg from './StitchingTbl/StichContractorTbl/StitchContractorReg';
import StitchContraInfo from './StitchingTbl/View/StitchContraInfo';
import StitchContraReturn from './Stitching/StitchContraReturn';
import StContraReturnReg from './StitchingTbl/StitchContraReturn/StContraReturnReg';
import StitchingUpdate from './StitchingEdit/StitchingUpdate';
// import KajeRegProduction from './KPIssueinwardTbl/KajeRegTable/KajeRegProduction';
import KajeProductionInfo from './KPIssueinwardTbl/View/KajeProductionInfo';
import StitchReturnInfo from './StitchingTbl/View/StitchReturnInfo';
// import PressRegProduction from './KPIssueinwardTbl/PressRegTbl/PressRegProduction';
// import PressProdInfo from './KPIssueinwardTbl/View/PressProdInfo';
import StContReturnInfo from './StitchingTbl/View/StContReturnInfo';
import StkProductionEntry from './Stock/StkProductionEntry';
import StkProductionReg from './StockTable/StkProductinTbl/StkProductionReg';
import StkProductionEdit from './StockEdit/StkProductionEdit';
import PackingEntry from './Packing/PackingEntry';
import PackingRegister from './PackingTables/PackingReg/PackingRegister';
import PackPrintStruct from './FieldsComponents/PackPrintStruct';
import PackingPrint from './PackingTables/View/PackingPrint';
import PackingEdit from './Packing/PackingEdit';
import InvoiceEntry from './Invoice/InvoiceEntry';
import InvoiceRegister from './InvoiceTbl/InvoiceTable/InvoiceRegister';
import PackingSlipRegister from './PackingTables/PackingSlipReg/PackingSlipRegister';
import SaleInvoice from './Packing/SaleInvoice';
import SaleInvoiceRegister from './PackingTables/InvoiceDetails/SaleInvoiceReg';
import CthIssueView from './Cutting/View/CthIssueView';
import BaleLump from './Inward/BaleLump';
import PIView from './Inward/PIView';
import BaleLumpView from './Inward/BaleLumpView';
import LumpMtrTbl2 from './UploadStock/LumpMtrTbl2';
import ClothStkView from './UploadStkTable/ClothStkTbl/ClothStkView';
import ClothStkBarcodeView from './UploadStkTable/ClothStkTbl/ClothStkBarcodeView';
import ClothIssueLump from './Cutting/ClothIssueLump';
import ClothIssueReturn from './CuttingTable/ClothIssueTbl/ClothIssueReturn';
import BrandEntry from './Master/BrandEntry';
import BrandEdit from './MasterEdit/BrandEdit';
import ItemMaterial from './Master/ItemMaterial';
import ItemMaterialReg from './MasterTables/ItemMaterialTbl/ItemMaterialReg';
import ItemPriceList from './Master/ItemPriceList';
import ItemPriceListReg from './MasterTables/ItemPriceListTbl/ItemPriceListReg';

import MaterialView from './MasterTables/ItemMaterialTbl/MaterialView';
import PriceListView from './MasterTables/ItemPriceListTbl/PriceListView';

import ItemMaterialEdit from './MasterEdit/ItemMaterialEdit';
import CuttingItemView from './Cutting/View/CuttingItemView';
import ContCutEntry2 from './Cutting/ContCutEntry2';
import StitchingItemView from './Stitching/StitchingItemView';
import CuttingEntry3 from './Cutting/CuttingEntry3';
import CuttingInward2 from './Cutting/CuttingInward2';
import NumberingEntry from './Numbering/NumberingEntry';
import NumberingRegister from './Numbering/NumberingRegister';
import NumberingInward from './Numbering/NumberingInward';
import NumberingInwardRegister from './Numbering/NumberingInwardRegister';
import FusioningEntry from './Fusioning/FusioningEntry';
import StitchEntry2 from './Stitching/StitchEntry2';
import StitchingReturn2 from './Stitching/StitchingReturn2';
import EmpJobwork from './Jobwork/EmpJobwork';
import AdvancePayment from './Jobwork/AdvancePayment';
import JobworkPaymentReg from './JobworkTbl/JobworkPaymentTbl/JobworkPaymentReg';
import JobwkPayView from './JobworkTbl/JobworkPaymentTbl/JobwkPayView';
import PaymentEntry from './Jobwork/PaymentEntry';
import PaymentRegister from './JobworkTbl/PaymentTbl/PaymentRegister';
import ContCutEntry3 from './Cutting/ContCutEntry3';
import ContractorInward2 from './Cutting/ContractorInward2';
import StitchContEntry2 from './Stitching/StitchContEntry2';
import StitchContReturn2 from './Stitching/StitchContReturn2';
import StkProdEntry2 from './Stock/StkProdEntry2';
import StkManuallyEntry2 from './Stock/StkManuallyEntry2';
import StkManuallyView from './Stock/StkManuallyView';
import ManualStkReg from './StockTable/ManualStkTbl/ManualStkReg';
import LoginPage from './LoginPage';
import LocationEntry from './Master/Location';
import LocationEdit from './MasterEdit/LocationEdit';
import ShiftingReg from './PackingTables/ShiftingTbl/ShiftingReg';
import ShiftingPrint from './PackingTables/View/ShiftingPrint';
import MainClothStkReg from './UploadStkTable/CommonClothStk/MainClothStk';
import NewDepartmentEntry from './NewEntry/NewDepartment';
import NewPannaEntry from './NewEntry/NewPannaEntry';
import NewBrandEntry from './NewEntry/NewBrandEntry';
import NewItemAvgEntry from './NewEntry/NewItemAvgEntry';
import MultiQuotation from './Sale/MultiQuotation';
import QuotationViewTwo from './Sale/View/QuotationViewTwo';
import TransferClothEntry from './UploadStock/TransferClothEntry';
import MultipleQuotationReg from './SaleTables/MultipleQuotTbl/MultipleQuotationReg';
import MultiQuotView from './SaleTables/View/MultiQuotView';
import DashboardPHP from './DashboardPHP';
import MultipleInvoice from './Packing/MultipleInvoice';
import NumberingIssueView from './CuttingTable/View/NumberingIssueView';
import SaleEntryReceipt from './Receipt/SaleEntryReceipt';
import ReceiptReg from './Receipt/ReceiptReg';
import RcptPrint from './Receipt/RcptPrint';
import SettlementEntry from './Receipt/SettlementEntry';
import SettlementReg from './Receipt/SettlementReg';
import SettlementPrint from './Receipt/SettlementPrint';
import SalesLedgerStatement from './Report/SalesLedgerStatement';
import FirmSalesLedgerStatement from './Report/FirmSalesLedgerStatement';
import SalesLedgerPrint from './Report/SalesLedgerPrint';
import OutStandingReport from './Report/OutStandingReport';
import SettlementSalesLedgerPrint from './Report/SettlementSalesLedgerPrint';
import OutStandingPrint from './Report/OutStandingPrint';
import FirmOutStandingPrint from './Report/FirmOutStandingPrint';
import FirmLedgerPrint from './Report/FirmLedgerPrint';
import FirmLedgerPrintTotalAmt from './Report/FirmLedgerPrintTotalAmt';
import Adv_RT_Settlement from './Settlement/Adv_RT_Settlement';
import TransferClothReg from './UploadStkTable/TransferClothTbl/TransferClothReg';
import NumberingIssueReturn from './Numbering/NumberingIssueReturn';
import NewEmpEntry from './NewEntry/NewEmpEntry';
import StockClothBale from './UploadStkTable/CommonClothStk/StockClothBale';
import StockClothUsed from './UploadStkTable/CommonClothStk/StockClothUsed';
import NumberingInwView from './CuttingTable/View/NumberingInwView';
import SOClothIssue from './Cutting/SOClothIssue';
import FusioningReg from './Fusioning/FusioningReg';
import FusionIssueView from './Fusioning/FusionIssueView';
import FusionReturnEntry from './Fusioning/FusionReturnEntry';
import FusioningInwReg from './Fusioning/FusioningInwReg';
import FusionInwView from './Fusioning/FusionInwView';
import ClothStkLocReg from './UploadStkTable/ClothStkTbl/ClothStkLocReg';
import LocationBaleLumpView from './UploadStkTable/ClothStkTbl/LocationBaleLumpView';
import KajeView from './Kaje/KajeView';
import KajeInwEntry from './Kaje/KajeInwEntry';
import TrimmingEntry from './Trimming/TrimmingEntry';
import KajeReturnReg from './KajeTbl/KajeReturnTbl/KajeReturnReg.jsx';
import TrimView from './Trimming/TrimView.jsx';
import TrimReg from './TrimmingTbl/TrimReg.jsx';
import TrimInfo from './TrimmingTbl/TrimInfo.jsx';
import TrimInward from './Trimming/TrimInward.jsx';
import TrimInwReg from './TrimmingTbl/TrimInwReg.jsx';
import PressView from './Press/PressView.jsx';
import PressReg from './PressTbl/PressReg.jsx';
import PressInfo from './PressTbl/PressInfo.jsx';
import PressInward from './Press/PressInward.jsx';
import PressInwReg from './PressTbl/PressInwReg.jsx';
import NumbInwView2 from './CuttingTable/View/NumbInwView2.jsx';
import FusionInwView2 from './Fusioning/FusionInwView2.jsx';
import KajeInwInfo from './KajeTbl/View/KajeInwInfo.jsx';
import KajeInwView from './KajeTbl/View/KajeInwView.jsx';
import TrimInwInfo from './TrimmingTbl/TrimInwInfo.jsx';
import TrimInwView from './TrimmingTbl/TrimInwView.jsx';
import PressInwInfo from './PressTbl/PressInwInfo.jsx';
import PressInwView from './PressTbl/PressInwView.jsx';
import InvoiceBill from './PackingTables/View/InvoiceBill.jsx';
import ManualStkItem from './StockTable/ManualStkTbl/ManualStkItem.jsx';
import ManualStkView from './StockTable/ManualStkTbl/ManualStkView.jsx';
import ManualStkBarcodeView from './StockTable/ManualStkTbl/ManualStkBarcodeView.jsx';


import PurchaseOrdView from './PurchaseTables/PurchaseOrderTbl/PurchaseOrdView.jsx';
import ManualStkEdit from './StockTable/ManualStkTbl/ManualStkEdit.jsx';
import SOClothIssue2 from './Cutting/SOClothIssue2.jsx';
import MaterialOutwardEntry2 from './Master/MaterialOutwardEntry.jsx';
import MaterialInwEntry2 from './Master/MaterialInwEntry.jsx';
import CuttingInwEntry3 from './Cutting/CuttingInward3.jsx';
import ContractorCutting4 from './Cutting/ContractorCutting4.jsx';
import StitchingContEntry3 from './Stitching/StitchingContEntry3.jsx';
import TransportBailEntry from './Master/TransportBailEntry.jsx';
import TransportBailRegister from './MasterTables/TransportTbl/TransportBailRegister.jsx';
import TransportBailWhatsappSendReg from './MasterTables/TransportTbl/TransportBailWhatsappSendReg.jsx';
import TransportBailEdit from './Master/TransportBailEdit.jsx';
import PrintingOutwardEntry from './Printing/PrintingOutwardEntry.jsx';
import PrintingOutwardRegister from './Printing/PrintingOutwardRegister.jsx';
import PrintingInward from './Printing/PrintingInward.jsx';
import PrintingInwardRegister from './Printing/PrintingInwardRegister.jsx';
import { Navigate } from "react-router-dom";
import ClothUseEntry from './CuttingTable/CutReturnTbl/ClothUseEntry.jsx';
import ItemMaterial2 from './Master/ItemMaterial2.jsx';
import AddUsers from './User/AddUsers.jsx';
import ManualStkTransfer from './StockTable/ManualStkTbl/ManualStkTransfer.jsx';
import ManStkTransferReg from './StockTable/ManualStkTbl/ManStkTransferReg.jsx';
import ManStkTransferView from './StockTable/ManualStkTbl/ManStkTransferView.jsx';
import WhPackPrint from './PackingTables/View/WhPackPrint.jsx';
import ItemMaterialEdit2 from './MasterEdit/ItemMaterialEdit2.jsx';
import MaterialPOEntry from './Purchase/MaterialPOEntry.jsx';
import NewMaterialEntry from './NewEntry/NewMaterialEntry.jsx';
import MaterialPOReg from './PurchaseTables/MaterialPOTbl/MaterialPOReg.jsx';
import MaterialPOView from './PurchaseTables/MaterialPOTbl/MaterialPOView.jsx';
import MaterialPIEntry from './Purchase/MaterialPIEntry.jsx';
import MaterialPIReg from './PurchaseTables/MaterialPITbl/MaterialPIReg.jsx';
import MaterialPIView from './PurchaseTables/MaterialPITbl/MaterialPIView.jsx';
import PackFlowEntry from './PackFlow/PackFlowEntry.jsx';
import PackFlowView from './PackFlow/PackFlowView.jsx';
import PackFlowReg from './PackFlow/PackFlowReg.jsx';
import PackFlowInward from './PackFlow/PackFlowInward.jsx';
import PackFlowInfo from './PackFlow/PackFlowInfo.jsx';
import PackFlowInwReg from './PackFlow/PackFlowInwReg.jsx';
import PackFlowInwView from './PackFlow/PackFlowInwView.jsx';
import PackFlowInwView2 from './PackFlow/PackFlowInwView2.jsx';
import NewMatInwEntry from './NewEntry/NewMatInwEntry.jsx';
import MatInwBarcodeReg from './MasterTables/MatInwardTbl/MatInwBarcodeReg.jsx';
import DirectMatPIEntry from './Purchase/DirectMatPIEntry.jsx';
import ClothStkReport from './UploadStock/ClothStkReport.jsx';
import ClothIssEntry2 from './Cutting/ClothIssEntry2.jsx';
import ClothReturnEntry from './Cutting/ClothReturnEntry.jsx';
import DirectPIEntry2 from './Inward/DirectPIEntry2.jsx';
import StReturnItemInfo from './StitchingTbl/View/StReturnItemInfo.jsx';



export default function Router() {
    const stockdata = {
        title: 'Ready Made Stock Entry',
        regTitle: 'Ready Made Stock Register',
        editTitle: 'Ready Made Stock Edit',
        editPath: 'ReadyMStkEdit',
        menu: [
            {
                title: 'Ready Made Stock',
                path: '/ReadyMStkEntry'
            },
            {
                title: 'Ready Made Stock Register',
                path: '/ReadyMStkTable'
            }
        ]
    };
    const manualdata = {
        title: 'Manual Stock Entry',
        regTitle: 'Manual Stock Register',
        editTitle: 'Manual Stock Edit',
        editPath: 'Manual-StockEdit',
        menu: [
            {
                title: 'Stock Production Entry',
                path: '/StkProductionEntry'
            },
            {
                title: 'Stock Production Register',
                path: '/StkProductionRegister'
            },
            {
                title: 'Manual Stock Entry',
                path: '/Manual-stock'
            },
            {
                title: 'Manual Stock Register',
                path: '/manual-stk-item-reg'
            },
            {
                title: 'Manual Stock (Barcode) Register',
                path: '/Manual-StockReg'
            },
            {
                title: 'Manual Stock Transfer',
                path: '/manual-stk-transfer'
            },
            {
                title: 'Manual Stock Transfer Reg',
                path: '/manual-stk-transfer-reg'
            },
        ]
    };

    const userdata = JSON.parse(localStorage.getItem('user'));
    const mainRoutes = useRoutes([
        {
            index: true,
            element: userdata
                ? <Navigate to="/Dashboard" replace />
                : <LoginPage />
        },
        {
            path: "Login",
            element: userdata
                ? <Navigate to="/Dashboard" replace />
                : <LoginPage />
        },
        {
            element: userdata ? (
                <Navigation>
                    <Outlet />
                </Navigation>
            ) : (
                <Navigate to="/Login" replace />
            ),
            children: [
                { path: 'Dashboard', element: <DashboardPHP /> },
                { path: 'FirmEntry', element: <FirmEntry /> },
                { path: 'FirmTable', element: <FirmTable /> },
                { path: 'EmployeeEntry', element: <EmployeeEntry /> },
                { path: 'EmployeeTable', element: <EmpTable /> },
                { path: 'DepartmentEntry', element: <DepartmentEntry /> },
                { path: 'DepartmentTable', element: <DepartmentTable /> },
                { path: 'PannaEntry', element: <PannaEntry /> },
                { path: 'PannaTable', element: <PannaTable /> },
                { path: 'ClothEntry', element: <ClothEntry /> },
                { path: 'ClothTable', element: <ClothTable /> },
                { path: 'SalePurchaseEntry', element: <SalePurchaseEntry /> },
                { path: 'SalePurchaseTable', element: <SalePurchaseTbl /> },
                { path: 'ItemEntry', element: <ItemMaster /> },
                { path: 'ItemTable', element: <ItemTbl /> },
                { path: 'ItemAverageMaster', element: <PannaItemAverage /> },
                { path: 'JobRateEntry', element: <JobRateEntry /> },
                { path: 'JobRateTable', element: <JobRateTable /> },
                { path: 'RackEntry', element: <RackEntry /> },
                { path: 'RackTable', element: <RackTable /> },
                { path: 'SchoolEntry', element: <SchoolEntry /> },
                { path: 'SchoolTable', element: <SchoolTable /> },
                { path: 'TransportEntry', element: <TransportEntry /> },
                // { path: 'TransportBailEntry', element: <TransportBailEntry /> },
                // { path: 'TransportBailRegister', element: <TransportBailRegister /> },
                // { path: 'TransportBailWhatsappSendReg', element: <TransportBailWhatsappSendReg /> },
                { path: 'TransportTable', element: <TransportTable /> },
                { path: 'LogoEntry', element: <LogoEntry /> },
                { path: 'LogoTable', element: <LogoTable /> },
                { path: 'MaterialEntry', element: <MaterialEntry /> },
                { path: 'MaterialTable', element: <MaterialTable /> },
                { path: 'MaterialInwardEntry', element: <MatInwardEntry /> },
                { path: 'material-inward-entry', element: <MaterialInwEntry2 /> },
                { path: 'MaterialInwardTable', element: <MatInwardTable /> },
                { path: 'material-inward-barcode-reg', element: <MatInwBarcodeReg /> },
                { path: 'MaterialOutwardEntry', element: <MatOutwardEntry /> },
                { path: 'material-outward-entry', element: <MaterialOutwardEntry2 /> },
                { path: 'MaterialOutwardTable', element: <MatOutwardTable /> },
                { path: 'MaterialStockTable', element: <MatStockTable /> },
                { path: 'ClothStkEntry', element: <ClothStkEntry /> },
                { path: 'ClothStkTable', element: <ClothStkTable /> },
                { path: 'manual-cloth-stock', element: <ClothStkEntry /> },
                { path: 'manual-cloth-stock-reg', element: <ClothStkTable /> },
                { path: 'ReadyMStkEntry', element: <ReadyMStkEntry data={stockdata} /> },
                { path: 'ReadyMStkTable', element: <ReadyMStkTable data={stockdata} /> },
                // { path: 'Manual-stock', element: <ReadyMStkEntry data={manualdata} /> },
                // { path: 'Manual-StockReg', element: <ReadyMStkTable data={manualdata} /> },
                { path: 'Manual-stock', element: <StkManuallyEntry2 data={manualdata} /> },
                { path: 'Manual-StockReg', element: <ManualStkReg /> },
                { path: 'PricePercentGEntry', element: <PricePercentGEntry /> },
                { path: 'PricePerGrpTable', element: <PricePercentTable /> },
                { path: 'PurchaseOrderEntry', element: <PurchaseOrderEntry /> },
                { path: 'PurchaseOrderTable', element: <PurchaseOrderTable /> },
                { path: 'POExtraEntry', element: <POExtraEntry /> },
                { path: 'PurchaseInwardEntry', element: <PurchaseInwardEntry /> },
                // { path: 'DirectPurchaseInwardEntry', element: <DirectPurchaseInwEntry /> },
                { path: 'DirectPurchaseInwardEntry', element: <DirectPIEntry2 /> },
                { path: 'PurchaseInwardTable', element: <PurInwardTable /> },
                { path: 'quotationentry', element: <QuotationEntry /> },
                { path: 'QuotationTable', element: <QuotationTable /> },
                { path: 'SaleOrder', element: <SaleOrder /> },
                { path: 'SaleOrderTable', element: <SaleOrderTable /> },
                { path: 'SaleOrderRate', element: <SaleOrderRate /> },
                { path: 'SORateManually', element: <SORateManually /> },
                { path: 'SOWiseEntry', element: <SOWiseEntry /> },
                { path: 'CuttingManuallyEntry', element: <CutManuallyEntry /> },
                // { path: 'RateAnalysis/:Id', element: <RateAnalysis /> },
                { path: 'SOQTwise', element: <SOqtwise /> },
                { path: 'DirectSO', element: <DirectSO /> },
                { path: 'CategoryMaster', element: <CategoryEntry /> },
                { path: 'CuttingSOwise', element: <CutSOwise /> },
                // { path: 'ClothIssueEntry', element: <ClothIssueEntry /> },
                { path: 'ClothIssueEntry', element: <ClothIssEntry2 /> },
                { path: 'ClothIssueReg', element: <ClothIssueReg /> },
                { path: 'ClothIssueReg2', element: <ClothIssueReg data={1} /> },
                // { path: 'CuttingEntry', element: <CuttingEntry /> },
                { path: 'CuttingRegister', element: <CuttingRegister /> },
                { path: 'ContractorEntry', element: <ContractorEntry /> },
                { path: 'ContractorRegister', element: <ContractorReg /> },
                { path: 'CuttingReturnRegister', element: <CuttingReturnReg /> },
                { path: 'ContractorReturnRegister', element: <ContractorReturnReg /> },
                // { path: 'StitchInhouseEntry', element: <StitchInhouseEntry /> },
                { path: 'StitchingRegister', element: <StitchingReg /> },
                // { path: 'StitchContractorEntry', element: <StitchContractorEntry /> },
                // { path: 'StitchContractorEntry', element: <StitchContEntry2 /> },
                { path: 'StitchContractorEntry', element: <StitchingContEntry3 /> },
                { path: 'StitchContractorReg', element: <StitchContractorReg /> },
                { path: 'StitchingReturnRegister', element: <StitchReturnReg /> },
                { path: 'StitchingContractorReturnRegister', element: <StContraReturnReg /> },
                { path: 'KajeEntry', element: <KajeEntry /> },
                { path: 'KajeRegister', element: <KajeRegister /> },
                // { path: 'PressEntry', element: <PressingEntry /> },
                // { path: 'Kaje-PressIssueInward', element: <KjPrIssueInw /> },
                { path: 'StockEntry-Production', element: <StockEntryProduction /> },
                // { path: 'KajeRegister-Production', element: <KajeRegProduction /> },
                // { path: 'PressRegister-Production', element: <PressRegProduction /> },
                // { path: 'PressProductionInfo/:Id', element: <PressProdInfo /> },
                // { path: 'StkProductionEntry', element: <StkProductionEntry /> },
                { path: 'StkProductionEntry', element: <StkProdEntry2 /> },
                { path: 'StkProductionRegister', element: <StkProductionReg /> },
                { path: 'packing-entry', element: <PackingEntry /> },
                { path: 'packing-register', element: <PackingRegister /> },
                { path: 'packing-slip-register', element: <PackingSlipRegister /> },
                { path: 'sale-invoice-register', element: <SaleInvoiceRegister /> },
                { path: 'PrintSturcture', element: <PackPrintStruct /> },
                { path: 'invoice-entry', element: <InvoiceEntry /> },
                { path: 'invoice-register', element: <InvoiceRegister /> },
                { path: 'cutting-entry', element: <CuttingEntry3 /> },
                { path: 'numbering-entry', element: <NumberingEntry /> },
                { path: 'numberingRegister', element: <NumberingRegister /> },
                { path: 'numbering-inward', element: <NumberingInward /> },
                { path: 'fusioning-entry', element: <FusioningEntry /> },
                { path: 'fusioning-reg', element: <FusioningReg /> },
                { path: 'brand-entry', element: <BrandEntry /> },
                // { path: 'item-material', element: <ItemMaterial /> },
                { path: 'item-material', element: <ItemMaterial2 /> },
                { path: 'item-material-reg', element: <ItemMaterialReg /> },
                { path: 'item-pricelist', element: <ItemPriceList /> },
                { path: 'item-pricelist-reg', element: <ItemPriceListReg /> },
                // { path: 'cutting-contractor-entry', element: <ContCutEntry2 /> },
                // { path: 'cutting-contractor-entry', element: <ContCutEntry3 /> },
                { path: 'cutting-contractor-entry', element: <ContractorCutting4 /> },
                { path: 'StitchInhouseEntry', element: <StitchEntry2 /> },
                { path: 'jobwork-entry', element: <EmpJobwork /> },
                { path: 'advance-payment', element: <AdvancePayment /> },
                { path: 'jobwork-payment-register', element: <JobworkPaymentReg /> },
                { path: 'payment-register', element: <PaymentRegister /> },
                { path: 'location-entry', element: <LocationEntry /> },
                { path: 'shifting-register', element: <ShiftingReg /> },
                { path: 'main-cloth-stock-reg', element: <MainClothStkReg /> },
                { path: 'transfer-cloth-entry', element: <TransferClothEntry /> },
                { path: 'multi-quotation', element: <MultiQuotation /> },
                { path: 'multi-quotation-reg', element: <MultipleQuotationReg /> },
                { path: 'transfer-cloth-reg', element: <TransferClothReg /> },
                { path: 'Sale-Receipt-Entry', element: <SaleEntryReceipt /> },
                { path: 'ReceiptReg', element: <ReceiptReg /> },
                { path: 'SettlementEntry', element: <SettlementEntry /> },
                { path: 'SettlementReg', element: <SettlementReg /> },
                { path: 'Sale-Ledger-Statement', element: <SalesLedgerStatement /> },
                { path: 'Firm-Ledger-Statement', element: <FirmSalesLedgerStatement /> },
                { path: 'OutStandingReport', element: <OutStandingReport /> },
                { path: 'SalesLedgerPrint/:firmId/:partyNm/:fromDt/:toDt/:cat', element: <SalesLedgerPrint /> },
                { path: 'SettlementSalesLedgerPrint/:firmId/:partyNm/:fromDt/:toDt/:cat', element: <SettlementSalesLedgerPrint /> },
                { path: 'OutStandingPrint/:firmId/:partyNm/:fromDt/:toDt', element: <OutStandingPrint /> },
                { path: 'FirmOutStandingPrint/:firmId/:fromDt/:toDt', element: <FirmOutStandingPrint /> },
                { path: 'FirmLedgerPrint/:firmId/:fromDt/:toDt/:cat', element: <FirmLedgerPrint /> },
                { path: 'FirmLedgerPrintTotalAmt/:firmId/:fromDt/:toDt/:cat', element: <FirmLedgerPrintTotalAmt /> },
                { path: 'Adv-RT-Settlement', element: <Adv_RT_Settlement /> },
                { path: 'numberinginwardRegister', element: <NumberingInwardRegister /> },
                { path: 'fusion-inward-reg', element: <FusioningInwReg /> },
                { path: 'cloth-stock-location-reg', element: <ClothStkLocReg /> },
                { path: 'trimming-entry', element: <TrimmingEntry /> },
                { path: 'kaje-inward-reg', element: <KajeReturnReg /> },
                { path: 'trimming-register', element: <TrimReg /> },
                { path: 'trimming-inward-reg', element: <TrimInwReg /> },
                { path: 'pressing-entry', element: <PressingEntry /> },
                { path: 'pressing-reg', element: <PressReg /> },
                { path: 'pressing-inward-reg', element: <PressInwReg /> },
                { path: 'manual-stk-item-reg', element: <ManualStkItem /> },
                { path: 'TransportBailEntry', element: <TransportBailEntry /> },
                { path: 'TransportBailRegister', element: <TransportBailRegister /> },
                { path: 'TransportBailWhatsappSendReg', element: <TransportBailWhatsappSendReg /> },
                { path: 'PrintingOutwardEntry', element: <PrintingOutwardEntry /> },
                { path: 'PrintingOutwardRegister', element: <PrintingOutwardRegister /> },
                { path: 'PrintingInwardRegister', element: <PrintingInwardRegister /> },
                { path: 'new-user-creating', element: <AddUsers /> },
                { path: 'manual-stk-transfer', element: <ManualStkTransfer /> },
                { path: 'manual-stk-transfer-reg', element: <ManStkTransferReg /> },
                { path: 'material-po-entry', element: <MaterialPOEntry /> },
                { path: 'material-po-reg', element: <MaterialPOReg /> },
                { path: 'material-pi-entry', element: <MaterialPIEntry /> },
                { path: 'material-pi-reg', element: <MaterialPIReg /> },
                { path: 'packing-flowise-entry', element: <PackFlowEntry /> },
                { path: 'packing-flowise-reg', element: <PackFlowReg /> },
                { path: 'packing-flowise-inward-reg', element: <PackFlowInwReg /> },
                { path: 'direct-material-pi-entry', element: <DirectMatPIEntry /> },
                { path: 'cloth-stock-report', element: <ClothStkReport /> },
            ]
        },
        // { path: 'FirmEdit/:Id', element: <FirmEdit /> },
        // { path: 'CuttingInward2/:Id', element: <CuttingInward2 /> },

        { path: 'new-employee-entry', element: <NewEmpEntry /> },
        { path: 'NewLogoEntry', element: <NewLogoEntry /> },
        { path: 'NewTransportEntry', element: <NewTransportEntry /> },
        { path: 'NewSchoolEntry', element: <NewSchoolEntry /> },
        { path: 'NewItemEntry', element: <NewItemEntry /> },
        { path: 'NewClothEntry', element: <NewClothEntry /> },
        { path: 'NewPartyEntry', element: <NewPartyEntry /> },
        { path: 'FirmEdit/:Id', element: <FirmEdit /> },
        { path: 'EmployeeEdit/:Id', element: <EmployeeEdit /> },
        { path: 'DepartmentEdit/:Id', element: <DepartmentEdit /> },
        { path: 'PannaEdit/:Id', element: <PannaEdit /> },
        { path: 'ClothEdit/:Id', element: <ClothEdit /> },
        { path: 'SalePurchaseEdit/:Id', element: <SalePurchaseEdit /> },
        { path: 'ItemEdit/:Id', element: <ItemEdit /> },
        { path: 'RackEdit/:Id', element: <RackEdit /> },
        { path: 'SchoolEdit/:Id', element: <SchoolEdit /> },
        { path: 'TransportEdit/:Id', element: <TransportEdit /> },
        { path: 'LogoEdit/:Id', element: <LogoEdit /> },
        { path: 'MaterialEdit/:Id', element: <MaterialEdit /> },
        { path: 'MaterialInwardEdit/:Id', element: <MatInwardEdit /> },
        { path: 'MaterialOutwardEdit/:Id', element: <MatOutwardEdit /> },
        { path: 'MaterialStockView/:Id', element: <MatStockView /> },
        { path: 'CuttingInward/:Id', element: <CuttingInward2 /> },
        { path: 'cutting-inward-entry/:Id', element: <CuttingInwEntry3 /> },
        { path: 'StkProductionEdit/:Id', element: <StkProductionEdit /> },
        { path: 'ReadyMStkEdit/:Id', element: <ReadyMStkEdit data={stockdata} /> },
        { path: 'Manual-StockEdit/:Id', element: <ReadyMStkEdit data={manualdata} /> },
        { path: 'packing-print/:Id', element: <PackingPrint /> },
        { path: 'whatsapp-packing-print/:Id', element: <WhPackPrint /> },
        { path: 'shifting-print/:Id', element: <ShiftingPrint /> },
        { path: 'packing-edit/:Id', element: <PackingEdit /> },
        { path: 'CuttingMainReturn/:Id', element: <MainReturnInfo /> },
        { path: 'CuttingReturnInfo/:Id', element: <CutReturnInfo /> },
        { path: 'CuttingFinalPrint/:Id', element: <CuttingFinalPrint /> },
        // { path: 'ContractorInward/:Id', element: <ContractorInward /> },
        { path: 'ContractorInward/:Id', element: <ContractorInward2 /> },
        { path: 'CuttingMainContReturn/:Id', element: <MainContReturnInfo /> },
        { path: 'ContractorReturnInfo/:Id', element: <ContReturnInfo /> },
        { path: 'ContCutFinalPrint/:Id', element: <ContCutFinalPrint /> },
        { path: 'packing-sale-invoice/:Id', element: <SaleInvoice /> },
        { path: 'CuttingInEdit/:Id', element: <CuttingInEdit /> },
        { path: 'SOinfo/:Id', element: <SOInfo /> },
        { path: 'SOMaterialInfo/:Id', element: <SOMaterialInfo /> },
        { path: 'SaleOrderEdit/:Id', element: <SaleOrderEdit /> },
        { path: 'StitchingEdit/:Id', element: <StitchingUpdate /> },
        { path: 'ClothStkEdit/:Id', element: <ClothStkEdit /> },
        { path: 'QuotationView', element: <QuotationView /> },
        { path: 'cloth-issue-view', element: <CthIssueView /> },
        { path: 'ClothIssueView/:Id', element: <ClothIssueView /> },
        { path: 'NumberingIssueView/:Id', element: <NumberingIssueView /> },
        { path: 'BaleLumpEntry/:Id', element: <BaleLump /> },
        { path: 'PIview/:Id', element: <PIView /> },
        { path: 'BaleLumpView', element: <BaleLumpView /> },
        { path: 'LumpMtrEntry2/:idx/:clothId/:mtr/:locnm', element: <LumpMtrTbl2 /> },
        { path: 'ClothStkView/:Id', element: <ClothStkView data={0} /> },
        { path: 'ClothStkBarcodeView/:Id/:infoId', element: <ClothStkBarcodeView data={0} /> },
        { path: 'ClothIssueLump/:Id/:bId', element: <ClothIssueLump /> },
        { path: 'ClothIssueLumpsView/:Id', element: <ClothStkView data={1} /> },
        { path: 'ClothIssueReturn/:Id', element: <ClothIssueReturn /> },
        { path: 'NumberingIssueReturn/:Id', element: <NumberingIssueReturn /> },
        { path: 'brand-edit/:Id', element: <BrandEdit /> },
        { path: 'material-view/:Id', element: <MaterialView /> },
        { path: 'pricelist-view/:Id/:cat', element: <PriceListView /> },
        // { path: 'item-material-edit/:Id', element: <ItemMaterialEdit /> },
        { path: 'item-material-edit/:Id', element: <ItemMaterialEdit2 /> },
        { path: 'cutting-item-view', element: <CuttingItemView /> },
        { path: 'CuttingInfoView/:Id', element: <CuttingInfoView /> },
        { path: 'StitchingInfo/:Id', element: <StitchingInfo /> },
        // { path: 'StitchingReturn/:Id', element: <StitchingReturn /> },
        { path: 'StitchingReturn/:Id', element: <StitchingReturn2 /> },
        { path: 'StitchReturnInfo/:Id', element: <StitchReturnInfo /> },
        { path: 'stitch-item-info/:Id', element: <StReturnItemInfo /> },
        { path: 'stitching-item-view', element: <StitchingItemView /> },
        { path: 'QuotationInfo/:Id', element: <QuotationInfo /> },
        { path: 'QuotPrint/:Id', element: <QuotPrint /> },
        { path: 'RateChange/:Id', element: <RateChange /> },
        { path: 'jobwork-payment-view/:Id', element: <JobwkPayView /> },
        { path: 'payment-entry/:Id', element: <PaymentEntry /> },
        { path: 'StitchContraInfo/:Id', element: <StitchContraInfo /> },
        // { path: 'StitchContraReturn/:Id', element: <StitchContraReturn /> },
        { path: 'StitchContraReturn/:Id', element: <StitchContReturn2 /> },
        { path: 'StitchingContractor-ReturnInfo/:Id', element: <StContReturnInfo /> },
        { path: 'Manuall-Stock-item-view', element: <StkManuallyView /> },
        { path: 'location-edit/:Id', element: <LocationEdit /> },
        { path: 'RateAnalysis/:Id', element: <RateAnalysis /> },
        { path: 'new-department-entry', element: <NewDepartmentEntry /> },
        { path: 'new-panna-entry', element: <NewPannaEntry /> },
        { path: 'new-brand-entry', element: <NewBrandEntry /> },
        { path: 'new-item-avg-entry', element: <NewItemAvgEntry /> },
        { path: 'QuotationViewTwo', element: <QuotationViewTwo /> },
        { path: 'multi-quotation-view/:Id', element: <MultiQuotView /> },
        { path: 'multiple-invoice', element: <MultipleInvoice /> },
        { path: 'KajeProductionInfo/:Id', element: <KajeProductionInfo /> },
        { path: 'Stock-given-cloths/:clothId/:locId', element: <StockClothBale /> },
        { path: 'Stock-used-cloths/:clothId/:locId', element: <StockClothUsed /> },
        { path: 'NumberingInwView/:Id', element: <NumberingInwView /> },
        { path: 'new-emp-entry', element: <NewEmpEntry /> },
        // { path: 'sowise-cloth-issue/:Id', element: <SOClothIssue /> },
        { path: 'sowise-cloth-issue/:Id', element: <SOClothIssue2 /> },
        { path: 'fusioning-issue-view/:Id', element: <FusionIssueView /> },
        { path: 'fusioning-return/:Id', element: <FusionReturnEntry /> },
        { path: 'fusion-inw-view/:Id', element: <FusionInwView /> },
        { path: 'Bale-Lump-View-location/:clothId/:locId', element: <LocationBaleLumpView /> },
        { path: 'kaje-view', element: <KajeView /> },
        { path: 'KajeInfo/:Id', element: <KajeInfo /> },
        { path: 'Kaje-return/:Id', element: <KajeInwEntry /> },
        { path: 'trimming-view', element: <TrimView /> },
        { path: 'trim-info/:Id', element: <TrimInfo /> },
        { path: 'trim-inward/:Id', element: <TrimInward /> },
        { path: 'pressing-view', element: <PressView /> },
        { path: 'press-info/:Id', element: <PressInfo /> },
        { path: 'press-inward/:Id', element: <PressInward /> },
        { path: 'number-inw-view/:Id', element: <NumbInwView2 /> },
        { path: 'fusion-inw-view2/:Id', element: <FusionInwView2 /> },
        { path: 'Kaje-Inw-Info/:Id', element: <KajeInwInfo /> },
        { path: 'Kaje-Inw-view/:Id', element: <KajeInwView /> },
        { path: 'trim-Inw-info/:Id', element: <TrimInwInfo /> },
        { path: 'Trim-Inw-view/:Id', element: <TrimInwView /> },
        { path: 'Press-Inw-info/:Id', element: <PressInwInfo /> },
        { path: 'Press-Inw-view/:Id', element: <PressInwView /> },
        { path: 'invoice-bill/:Id', element: <InvoiceBill /> },
        { path: 'manual-stk-view/:Id', element: <ManualStkView /> },
        { path: 'manual-stk-view-barcode/:barcode/:itemId', element: <ManualStkBarcodeView /> },
        { path: 'purchase-order-view/:Id', element: <PurchaseOrdView /> },
        { path: 'manual-stk-edit/:Id', element: <ManualStkEdit /> },
        { path: 'TransportBailEdit/:Id', element: <TransportBailEdit /> },
        { path: 'ClothIssueEdit/:Id', element: <ClothIssueEdit /> },
        { path: 'printing-inward/:Id', element: <PrintingInward /> },
        { path: 'cloth-use-entry/:Id', element: <ClothUseEntry /> },
        { path: 'manual-stk-transfer-view/:Id', element: <ManStkTransferView /> },
        { path: '/rcptPrint/:Id/:type', element: <RcptPrint /> },
        { path: '/settlementPrint/:Id/:type', element: <SettlementPrint /> },
        { path: 'new-material-entry', element: <NewMaterialEntry /> },
        { path: 'material-po-view/:Id', element: <MaterialPOView /> },
        { path: 'material-pi-view/:Id', element: <MaterialPIView /> },
        { path: 'Flow-Pack-view', element: <PackFlowView /> },
        { path: "MaterialInwardView/:inwardNo/:inwardType", element: <MatInwardView /> },
        { path: "MaterialInwardBarcode/:inwardNo/:inwardType", element: <MatInwardBarcode /> },
        { path: 'pack-flow-inward/:Id', element: <PackFlowInward /> },
        { path: 'pack-flow-info/:Id', element: <PackFlowInfo /> },
        { path: 'pack-flow-inward-info/:Id', element: <PackFlowInwView /> },
        { path: 'pack-flow-inward-view/:Id', element: <PackFlowInwView2 /> },
        { path: 'new-material-inward-entry/:Id', element: <NewMatInwEntry /> },
        { path: 'cloth-use-return-entry/:Id', element: <ClothReturnEntry /> },
    ])
    return mainRoutes;
}

